import { useCallback, useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { GradeCard } from "@/components/deck/GradeCard";

export const GradesPanel = ({ open, onClose, onCount }) => {
  const [items, setItems] = useState([]);
  const [hideDone, setHideDone] = useState(true);

  const load = useCallback(() => api.get("/gear/grades").then((r) => {
    setItems(r.data);
    onCount(r.data.filter((x) => !x.grade?.approved && x.review?.status === "new").length);
  }).catch(() => {}), [onCount]);

  useEffect(() => { load(); const t = setInterval(load, open ? 5000 : 30000); return () => clearInterval(t); }, [load, open]);

  const grade = async (x) => {
    try {
      await api.post(`/gear/${x.uid}/${x.id}/grade`, {});
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const regrade = async (x, body) => {
    try { await api.post(`/gear/${x.uid}/${x.id}/regrade`, body); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const approve = async (x, gradeV, reply) => {
    try { await api.post(`/gear/${x.uid}/${x.id}/approve`, { grade: gradeV, reply }); toast.success(`Approved as ${gradeV}. The member can see it.`); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  if (!open) return null;
  const list = hideDone ? items.filter((x) => !x.grade?.approved && !["published", "declined"].includes(x.review?.status)) : items;
  const ungraded = items.filter((x) => !x.grade && !x.grade?.approved);
  return (
    <aside className="lg lg-inbox lg-intake" data-testid="grades-panel">
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <h3 style={{ fontSize: 18, margin: 0, marginRight: "auto" }}>Gear grades</h3>
        {ungraded.length > 0 && <button className="lg-btn sm" onClick={() => ungraded.forEach(grade)} data-testid="grades-grade-all"><Sparkles size={13} />Grade all new ({ungraded.length})</button>}
        <button className="lg-btn ghost sm" onClick={onClose} data-testid="grades-close"><X size={14} /></button>
      </div>
      <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 12 }}>The AI only copies the numbers from each member's 4 screenshots. Your Grading rules decide the grade: Initial Charge for Arena & Atlantis, weighted stats for Historic & Tesla. Fix any number and recalculate. Approving sets the status to "Under review" and sends your reply to the member.</p>
      <label style={{ fontSize: 13, display: "flex", gap: 6, marginBottom: 14 }}>
        <input type="checkbox" checked={hideDone} onChange={(e) => setHideDone(e.target.checked)} data-testid="grades-hide-approved" />Hide approved
      </label>
      {list.length === 0 && <p data-testid="grades-empty">No gear submissions waiting.</p>}
      {list.map((x) => <GradeCard key={x.id} x={x} onGrade={() => grade(x)} onApprove={(g, r) => approve(x, g, r)} onRegrade={(b) => regrade(x, b)} />)}
    </aside>
  );
};
